import styled from 'styled-components';

const TwoColumnWrapper = styled.div`
  display: flex;
  width: 100%;
`;

export default TwoColumnWrapper;
